import { Component, DestroyRef, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogControlService } from 'src/app/shared/services/dialog-control.service';
import { DriverCreatedSucessComponent } from '../../driver/driver-created-sucess/driver-created-sucess.component';
import { InvitedDriverService } from '@core/services/invited-driver.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { emailOrPhoneValidator } from '@shared/services/custom-validatior.abstract';
import { CommonFunctions } from '@shared/common-functions';
import { HttpErrorResponse } from '@angular/common/http';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-invite-driver-modal',
  templateUrl: './invite-driver-modal.component.html',
  styleUrls: ['./invite-driver-modal.component.scss']
})
export class InviteDriverModalComponent {
  readonly destroyRef = inject(DestroyRef);
  inviteDriverForm: FormGroup;

  constructor(
    private readonly fb: FormBuilder,
    private readonly dialogControlService: DialogControlService,
    private readonly invitedDriverService: InvitedDriverService,
    private readonly toastService: ToastService
  ) {

    this.inviteDriverForm = this.fb.group({
      email: ['', [Validators.required,emailOrPhoneValidator]],
    })
  }

  closeModal() {
    this.dialogControlService.closeDialog();
  };

  getEmailError(): string | null {
    const emailControl = this.inviteDriverForm.get('email');
    if (emailControl && (emailControl.dirty || emailControl.touched)) {
      switch (true) {
        case emailControl.hasError('required'):
          return 'required';
        case emailControl.hasError('pattern'):
          return 'pattern';
        default:
          return null;
      }
    }
    return null;
  }

  preventFirstSpace(event: KeyboardEvent): void {
    CommonFunctions.preventFirstSpaces(event);
  }

  sendInviteToDriver() {
    const email : string = this.inviteDriverForm.value.email;
    const isEmail = email.includes('@');
    let data = {
      emailId:  isEmail ? email : null,
      mobileNumber: isEmail ? null : email,
    }
    if (this.inviteDriverForm.valid) {
      this.invitedDriverService.sendInviteToDriver(data)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({

        next: (_response) => {
            this.closeModal();

this.dialogControlService.openDialog(DriverCreatedSucessComponent, {
              width: "30%",
              data: {
                successMessage: 'The invitation has been sent successfully!'
              }
            })
        }, error: (error : HttpErrorResponse) => {
          this.toastService.showToastMessage('error', 'Error', error.error.message);
          
        }
      })
    }
    else{
      this.inviteDriverForm.markAllAsTouched();
    }

  }

}
